'use strict';

var _decorator = require('./decorator');

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENTS = ['AttributionControl', 'Circle', 'CircleMarker', 'FeatureGroup', 'GeoJSON', 'GridLayer', 'ImageOverlay', 'LayerGroup', 'LayersControl', 'Map', 'MapComponent', 'MapControl', 'MapLayer', 'Marker', 'Pane', 'Path', 'Polygon', 'Polyline', 'Popup', 'Rectangle', 'ScaleControl', 'TileLayer', 'Tooltip', 'WMSTileLayer', 'ZoomControl'];

var COMPONENT_MAP = COMPONENTS.reduce(function (map, name) {
	map[name] = (0, _decorator2.default)(name);
	return map;
}, {});

module.exports = COMPONENT_MAP;


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet-universal/dist/index.js
// module id = 1938
// module chunks = 0